<template>
  <div class="token-expired" v-if="tokenExpired">
    <h4>{{ $t("token.expired.title") }}</h4>
    <p>{{ $t("token.expired.message") }}</p>
  </div>
  <template v-else>
  <div class="loading" v-if="pending">{{ $t("message.loading") }}&#8230;</div>
  <web-socket-connection></web-socket-connection>
  <div class="alert alert-warning token-expiry-warning" v-if="tokenExpiringSoon">
    {{ $t("token.expiresSoon", { date: tokenExpiresAtFormatted }) }}
  </div>
  <pull-refresh
    v-model="loading"
    @refresh="onRefresh"
    :pulling-text="$t('pullToRefresh.pullingText')"
    :loosing-text="$t('pullToRefresh.loosingText')"
    :loading-text="$t('pullToRefresh.loadingText')"
    :success-text="$t('pullToRefresh.successText')"
  >
    <time-sheet-selector v-if="true" />
    <!-- <div class="row" v-if="false">
        <div class="col-12">
          <label for="currentDateRange" class="form-label">{{
            currentDate
          }}</label>
          <input
            type="range"
            class="form-range"
            :min="-86400000"
            :max="86400000"
            step="6000"
            id="currentDateRange"
            v-model="currentTimeMillis"
          />
        </div>
      </div> -->
    <router-view></router-view>
  </pull-refresh>
  </template>
</template>

<script>
import TimeSheetSelector from "./shared/time_sheet_selector.vue";
import WebSocketConnection from "./shared/web_socket_connection.vue";
import PullRefresh from "pull-refresh-vue3";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MainLayout",
  components: {
    TimeSheetSelector,
    PullRefresh,
    WebSocketConnection,
  },
  data() {
    return {
      currentDate: new Date("2021-06-04T07:30:00.000+02:00"),
      show: false,
      currentTimeMillis: null,
      timer: null,
      dev: true,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      setReloading: "navigation/setReloading",
    }),
    onRefresh() {
      this.setReloading(true);
    },
  },
  computed: {
    ...mapGetters({
      pending: "timeSheets/pending",
      reloading: "navigation/getReloading",
      tokenExpired: "permissions/isTokenExpired",
      tokenExpiringSoon: "permissions/isTokenExpiringSoon",
      tokenExpiresAt: "permissions/tokenExpiresAt",
    }),
    tokenExpiresAtFormatted() {
      return this.tokenExpiresAt?.toLocaleDateString(this.$i18n.locale) ?? "";
    },
  },
  watch: {
    currentTimeMillis(newVal) {
      this.currentDate = new Date("2021-06-04T07:30:00.000+02:00");
      this.currentDate.setMilliseconds(newVal * 1);
    },
    reloading(newVal) {
      this.loading = newVal;
    },
  },
};
</script>

<style lang="scss">
#app {
  touch-action: manipulation;
}

.token-expired {
  margin: 30vh auto 0;
  max-width: 22rem;
  padding: 0 1rem;
  text-align: center;
}

.token-expiry-warning {
  margin: 0.5rem;
  text-align: center;
}

.container-fluid {
  overflow-x: hidden;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 9999999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));

  background: -webkit-radial-gradient(
    rgba(20, 20, 20, 0.8),
    rgba(0, 0, 0, 0.8)
  );
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 150ms infinite linear;
  -moz-animation: spinner 150ms infinite linear;
  -ms-animation: spinner 150ms infinite linear;
  -o-animation: spinner 150ms infinite linear;
  animation: spinner 150ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
